document.addEventListener("DOMContentLoaded", function () {
    const bundleProducts = document.querySelectorAll(".block--product");
    const selectedCountElement = document.getElementById("selected-count");
    const addToCartButton = document.querySelector(".add--alltocart");
    const buttonText = addToCartButton.querySelector(".bundle--button-text");
    const spinner = addToCartButton.querySelector(".bundle--spinner");
  
    let selectedProducts = [];
  
    bundleProducts.forEach((product) => {
      const selectButton = product.querySelector(".custom--button");
      const quantitySelector = product.querySelector(".bundle--quantity-selector");
      const quantityInput = product.querySelector(".bundle--quantity-input");
      const minusButton = product.querySelector(".bundle--quantity-minus");
      const plusButton = product.querySelector(".bundle--quantity-plus");
  
      const productId = selectButton.getAttribute("data-product-id");
      const productHandle = product.getAttribute("data-product-handle");
      const maxInventory = parseInt(
        quantitySelector.getAttribute("data-product-quantity"),
        10
      );
  
      minusButton.addEventListener("click", () => {
        const currentValue = parseInt(quantityInput.value);
        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
          updateSelectedProductQuantity(productId, quantityInput.value);
        }
      });
  
      plusButton.addEventListener("click", () => {
        let currentValue = parseInt(quantityInput.value);
        if (currentValue < maxInventory) {
          quantityInput.value = currentValue + 1;
          updateSelectedProductQuantity(productId, quantityInput.value);
        }
      });
  
      quantityInput.addEventListener("change", () => {
        let value = parseInt(quantityInput.value);
        if (isNaN(value)) value = 1;
        if (value < 1) value = 1;
        if (value > maxInventory) value = maxInventory;
        quantityInput.value = value;
        updateSelectedProductQuantity(productId, value);
      });
  
      selectButton.addEventListener("click", function () {
        if (this.classList.contains("selected")) {
          this.classList.remove("selected");
          this.textContent = "Select";
          product.classList.remove("selected-product");
  
          minusButton.setAttribute("disabled", "disabled");
          quantityInput.setAttribute("disabled", "disabled");
          plusButton.setAttribute("disabled", "disabled");
  
          selectedProducts = selectedProducts.filter(
            (item) => item.id !== productId
          );
        } else {
          this.classList.add("selected");
          this.textContent = "Selected";
          product.classList.add("selected-product");
  
          minusButton.removeAttribute("disabled");
          quantityInput.removeAttribute("disabled");
          plusButton.removeAttribute("disabled");
  
          const existingProduct = selectedProducts.find(
            (item) => item.id === productId
          );
          if (!existingProduct) {
            selectedProducts.push({
              id: productId,
              handle: productHandle,
              quantity: parseInt(quantityInput.value),
              maxInventory: maxInventory,
            });
          }
        }
  
        updateSelectedCount();
      });
    });
  
    function updateSelectedProductQuantity(productId, quantity) {
      const product = selectedProducts.find((item) => item.id === productId);
      if (product) {
        product.quantity = parseInt(quantity);
      }
      updateSelectedCount();
    }
  
    function updateSelectedCount() {
      const totalItems = selectedProducts.reduce(
        (sum, product) => sum + product.quantity,
        0
      );
  
      selectedCountElement.textContent = totalItems;
  
      // Enable button when at least 1 item is selected (changed from 10)
      if (totalItems >= 1) {
        addToCartButton.removeAttribute("disabled");
      } else {
        addToCartButton.setAttribute("disabled", "disabled");
      }
    }
  
    addToCartButton.addEventListener("click", async function () {
      if (selectedProducts.length === 0) return;
  
      buttonText.style.display = "none";
      spinner.style.display = "block";
      addToCartButton.setAttribute("disabled", "disabled");
  
      try {
        const items = selectedProducts.map((product) => ({
          id: product.id,
          quantity: product.quantity,
        }));
  
        await addMultipleProductsToCart(items);
        window.location.href = "/cart";
      } catch (error) {
        console.error("Error adding products to cart:", error);
        alert("There was an error adding products to your cart. Please try again.");
      } finally {
        buttonText.style.display = "block";
        spinner.style.display = "none";
        updateSelectedCount();
      }
    });
  
    function addMultipleProductsToCart(items) {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.description) {
            throw new Error(data.description);
          }
          return data;
        });
    }
  
    function resetSelection() {
      selectedProducts = [];
  
      bundleProducts.forEach((product) => {
        const selectButton = product.querySelector(".custom--button");
        const quantityInput = product.querySelector(".bundle--quantity-input");
        const minusButton = product.querySelector(".bundle--quantity-minus");
        const plusButton = product.querySelector(".bundle--quantity-plus");
  
        selectButton.classList.remove("selected");
        selectButton.textContent = "Select";
        product.classList.remove("selected-product");
  
        minusButton.setAttribute("disabled", "disabled");
        quantityInput.setAttribute("disabled", "disabled");
        plusButton.setAttribute("disabled", "disabled");
  
        quantityInput.value = 1;
      });
  
      updateSelectedCount();
    }
  
    updateSelectedCount();
  });
  